import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_cloud",
  "use": "micro_cloud-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_cloud\"><path fill-rule=\"evenodd\" d=\"M8.125 4.125v.625C9.159 4.75 10 5.591 10 6.625A1.877 1.877 0 0 1 8.125 8.5H2.5A2.503 2.503 0 0 1 0 6a2.5 2.5 0 0 1 1.931-2.429A3.124 3.124 0 0 1 5 1a3.129 3.129 0 0 1 3.125 3.125Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol